import { Box, Stack, Typography } from '@mui/material'
import { t } from 'i18next'

export const BaseCurrency: React.FC<{ baseCurrency: {id: number, name: string}}> = ({ baseCurrency }): JSX.Element => (
  <Box sx={{ paddingTop: 2, mb: '32px' }}>
    <Stack direction={'row'} alignItems={'center'} spacing={'16px'}>
      <Box
        sx={{
          width: '150px',
          marginLeft: '16px',
          height: '46px',
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: 14,
            color: '#000000',
          }}
        >
          {t('currency.key_currency')}
        </Typography>
      </Box>
      <Box>{baseCurrency.name}</Box>
    </Stack>
  </Box>
)
